var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentCard',[_c('EditColumn',{attrs:{"submitText":"Add Group Members","title":"Add Group Members","error":_vm.errorMessage},on:{"submit":_vm.handleSubmit,"cancel":function($event){return _vm.transitionStatus('idle')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }